<template>
    <div>
        <div :class="[`image-list-box-${boxHeight}`]">
            <component :is="isAttribute" :class="['gallery-card-image-title', 'pointer', {fullscreen: cover}]" v-bind:style="style"
                v-bind="linkAttributes" v-light-box="lightBox ? resolvedLink : false">
                <img v-if="!cover" :src="image" :alt="alt"/>
                <slot name="badge"></slot>
            </component>
            <div v-if="!hideActions" class="gallery-card-image-actions no-margin">
                <component :is="isAttribute" v-bind="linkAttributes" v-light-box="lightBox ? resolvedLink : false" class="gallery-card-image__filename pointer">
                    <span><slot name="title"></slot></span>
                    <br>
                    <span class="additional-information"><slot name="additional-information"></slot></span>
                </component>
                <slot name="buttons"></slot>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {type RouteLocationRaw, useRouter} from 'vue-router';
    import {computed} from 'vue';

    const props = withDefaults(
        defineProps<{
            image?: string;
            link?: RouteLocationRaw | string;
            boxHeight?: 'low' | 'high';
            alt?: string;
            cover?: boolean;
            lightBox?: boolean;
            hideActions?: boolean;
        }>(),
        {
            image: '',
            link: () => ({}),
            boxHeight: 'low',
            alt: '',
            cover: false,
            lightBox: false,
            hideActions: false,
        },
    );

    const router = useRouter();

    const style = computed(() =>
    {
        if (props.cover)
        {
            return {
                'background-image': `url(${props.image})`,
            };
        }

        return {};
    });

    const resolvedLink = computed(() =>
    {
        if ('string' === typeof props.link)
        {
            return props.link;
        }

        return router.resolve(props.link).href;
    });

    const isAttribute = computed(() =>
    {
        if (!props.lightBox)
        {
            return 'router-link';
        }

        return 'a';
    });

    const linkAttributes = computed(() =>
    {
        if (!props.lightBox)
        {
            let attributes: Record<string, any> = {
                to: props.link,
            };

            if (props.cover)
            {
                attributes.alt           = props.alt;
                attributes['aria-label'] = props.alt;
            }

            return attributes;
        }

        let attributes: Record<string, string> = {
            href: resolvedLink.value,
        };

        if (props.cover)
        {
            attributes.alt           = props.alt;
            attributes['aria-label'] = props.alt;
        }

        if (!props.alt && !props.cover)
        {
            attributes['aria-label'] = 'Link';
        }

        return attributes;
    });
</script>